export default "__VITE_ASSET__5835134a__"